<script lang="ts">
  import type { ClassValue } from "svelte/elements";
  import CopyToClipboard from "./CopyToClipboard.svelte";

  interface Props {
    text: string;
    inline?: boolean;
    copyable?: boolean;
    class?: ClassValue;
  }

  let { text, inline = false, copyable = true, class: className }: Props = $props();
</script>

<code
  class={[
    "font-mono text-xs",
    inline
      ? "inline-block rounded-[4px] bg-alpha-050 px-1 text-foreground-secondary"
      : "flex items-center justify-between gap-4 rounded-lg border border-border bg-mono-000 px-3 py-2 leading-4 text-foreground-primary",
    className,
  ]}
>
  <pre class="truncate">{text}</pre>

  {#if !inline && copyable}
    <CopyToClipboard {text} />
  {/if}
</code>
